import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@fortawesome/fontawesome-svg-core/styles.css'; // Assuming your main App component is in a file named App.js

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root') // Assuming you have a root element in your HTML file with the id "root"
);